import Extension from "../base/extension";

class CountryDetect extends Extension {
  constructor(name) {
    super(name);
  }

  async onReady(){
    try {
      let jsonString = await this.getUserGeoData();
      let countryJson = JSON.parse(jsonString);
      if(countryJson.error){
        console.warn(this.logPrefix, "Error getting location");
        return;
      }
  
      // Dispatch a CustomEvent for other extensions to listen for / react to
      let event = new CustomEvent("geodata:country:loaded", {
        detail: {
          data: countryJson
        }
      });
      document.dispatchEvent(event);

      console.log(this.logPrefix, "Country data loaded", countryJson);
    } catch (error) {
      console.warn(this.logPrefix, 'Error getting location', error);
    }
  }

  /**
   * Get either cached or fresh geolocation data. If not cached, store as cookie
   * @returns {Promise} a Promise
   */
  getUserGeoData() {
    if(Cookies.get('geodata:country') === undefined) {
      return this.fetchUserGeoData();
    } else {
      return Promise.resolve(Cookies.get("geodata:country"));
    }
  }

  /**
   * Get the current user's geographic data from their IP via Geoapify
   * @returns {Promise} a Promise
   */
  async fetchUserGeoData() {
    try {
      let response = await fetch(window.routes.browsing_context_suggestions_url);
      let result = await response.json();
      console.log(this.logPrefix, "Result from Shopify", result);
      let jsonString = JSON.stringify({ country: { iso_code: result.detected_values.country.handle } });
      Cookies.set("geodata:country", jsonString);
      return jsonString;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default CountryDetect;